import React, { Suspense, lazy, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom'
import { Layout, Typography, Menu, Image, Spin, Button, Drawer } from 'antd'
import { HomeOutlined, PhoneOutlined, CalendarOutlined, UserOutlined, ToolOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons'

// Lazy loading for better performance
const HomePage = lazy(() => import('./components/HomePage'))
const ContactPage = lazy(() => import('./components/ContactPage'))
const SchedulePage = lazy(() => import('./components/SchedulePage'))
const AboutPage = lazy(() => import('./components/AboutPage'))
const ServicesPage = lazy(() => import('./components/ServicesPage'))

import logo from './assets/img/logo.webp'
import './App.css'

const { Header, Content, Footer } = Layout
const { Title } = Typography

function AppHeader() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const location = useLocation()

  const currentKey = location.pathname === '/' ? 'home' 
    : location.pathname.replace('/', '')

  const menuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: <Link to="/" onClick={() => setDrawerOpen(false)}>Home</Link>,
    },
    {
      key: 'about',
      icon: <UserOutlined />,
      label: <Link to="/about" onClick={() => setDrawerOpen(false)}>About</Link>,
    },
    {
      key: 'services',
      icon: <ToolOutlined />,
      label: <Link to="/services" onClick={() => setDrawerOpen(false)}>Services</Link>,
    },
    {
      key: 'schedule',
      icon: <CalendarOutlined />,
      label: <Link to="/schedule" onClick={() => setDrawerOpen(false)}>Schedule Inspection</Link>,
    },
    {
      key: 'contact',
      icon: <PhoneOutlined />,
      label: <Link to="/contact" onClick={() => setDrawerOpen(false)}>Contact Us</Link>,
    },
  ]

  return (
    <>
      <Header className="site-header" style={{ 
        background: '#fff', 
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        height: 'auto',
        minHeight: '64px',
        lineHeight: 'normal',
        paddingTop: '8px',
        paddingBottom: '8px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <Image
              src={logo}
              alt="LiveSure Home Inspections Logo"
              style={{ 
                height: '50px', 
                width: 'auto',
                marginRight: '12px'
              }}
              preview={false}
              loading="eager"
              sizes="50px"
            />
            <Title level={3} className="header-title" style={{ margin: '0', color: '#7D765A' }}>
              LiveSure Home Inspections
            </Title>
          </Link>
        </div>

        {/* Desktop menu */}
        <Menu 
          className="desktop-menu"
          mode="horizontal" 
          selectedKeys={[currentKey]}
          items={menuItems}
          style={{ 
            border: 'none',
            background: 'transparent',
            fontSize: '16px'
          }}
          theme="light"
        />

        {/* Mobile hamburger button */}
        <Button
          className="mobile-menu-btn"
          type="text"
          icon={<MenuOutlined style={{ fontSize: '24px', color: '#7D765A' }} />}
          onClick={() => setDrawerOpen(true)}
          aria-label="Open navigation menu"
        />
      </Header>

      {/* Mobile drawer */}
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Image
              src={logo}
              alt="LiveSure"
              style={{ height: '36px', width: 'auto', marginRight: '10px' }}
              preview={false}
            />
            <span style={{ color: '#7D765A', fontWeight: 'bold' }}>LiveSure</span>
          </div>
        }
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={280}
        closeIcon={<CloseOutlined style={{ color: '#7D765A' }} />}
        styles={{ body: { padding: 0 } }}
      >
        <Menu
          mode="vertical"
          selectedKeys={[currentKey]}
          items={menuItems}
          style={{ border: 'none', fontSize: '16px' }}
        />
      </Drawer>
    </>
  )
}

function App() {
  return (
    <Router>
      <Layout style={{ minHeight: '100vh' }}>
        <AppHeader />
        
        <Content style={{ background: '#f0f2f5', width: '100%', maxWidth: 'none' }}>
          <Suspense fallback={
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              minHeight: '400px' 
            }}>
              <Spin size="large" />
            </div>
          }>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </Suspense>
        </Content>
        
        <Footer style={{ textAlign: 'center', background: '#fff' }}>
          LiveSure Home Inspections, LLC ©2025 - All Rights Reserved.
        </Footer>
      </Layout>
    </Router>
  )
}

export default App
